import { render, staticRenderFns } from "./login-layout-recovery-email-sent.vue?vue&type=template&id=7e1f643d&scoped=true&"
import script from "./login-layout-recovery-email-sent.ts?vue&type=script&lang=ts&"
export * from "./login-layout-recovery-email-sent.ts?vue&type=script&lang=ts&"
import style0 from "./login-layout-recovery-email-sent.scss?vue&type=style&index=0&id=7e1f643d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1f643d",
  null
  
)

export default component.exports